import { useEffect, useState, useRef } from 'react';

const useScrollPositioning = ({ cache, query, fetchMore }) => {
  const [scroll, setScroll] = useState(cache.scroll.top);
  const resultsRef = useRef(null);

  // cache & restore scroll as modal opens & closes (or tabs change)
  useEffect(() => {
    if (cache.scroll.top !== scroll) {
      cache.scroll.top = scroll;
    } else {
      if (resultsRef.current) resultsRef.current.scrollTop = scroll;
    }

    // if we're at the bottom, fetchMore
    const scrollRemaining =
      resultsRef.current.scrollHeight -
      resultsRef.current.scrollTop -
      resultsRef.current.offsetHeight;

    if (
      fetchMore && // has been initialized
      resultsRef.current.scrollTop !== 0 && // there are results
      scrollRemaining < 10 // we are at (or very close to) the bottom
    ) {
      fetchMore();
    }
  }, [scroll, cache, fetchMore]);

  // reset scroll && selection if query changes
  useEffect(() => {
    if (cache.scroll.query !== query) {
      cache.scroll.query = query;
      setScroll(0);
      resultsRef.current.scrollTop = 0;
    }
  }, [cache, query]);

  return {
    setScroll,
    resultsRef,
  };
};

export default useScrollPositioning;
